<script setup>
import { useStore } from '@/store';

defineProps({
  prompts: {
    type: Array,
    default: () => [],
  },
});

const store = useStore();

const handleOpenHelp = () => {
  store.dispatch('automation/openOnboardingModal', { triggerOrigin: 'help' });
};
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.bodyTitle">
      {{ $t('chatMessage.helpPrompt.title') }}
    </div>
    <div :class="$style.helps">
      <!--
        TOGGLE_MODAL_INTRODUCTION_AUTOMATION_ENABLED
        TODO: Remove FeatureFlag component and keep default
      -->
      <FeatureFlag name="toggleModalIntroductionAutomationEnabled">
        <XButton
          :class="$style.helpPrompt"
          model="plain"
          @click="handleOpenHelp"
        >
          <div :class="$style.content">
            <span :class="$style.text">
              {{ $t('chatMessage.helpPrompt.firstSteps') }}
            </span>
            <XIcon
              :class="$style.icon"
              icon="arrow-right"
            />
          </div>
        </XButton>
      </FeatureFlag>
      <XButton
        v-for="(item, index) in prompts"
        :key="index"
        :class="$style.helpPrompt"
        model="plain"
        @click="$emit('send-message', item)"
      >
        <div :class="$style.content">
          <span :class="$style.text">
            {{ item }}
          </span>
          <XIcon
            :class="$style.icon"
            icon="arrow-right"
          />
        </div>
      </XButton>
    </div>
  </div>
</template>

<style lang="scss" module>
.container {
  .bodyTitle {
    margin-bottom: var(--space-small-x);
    font-weight: var(--font-weight-medium);
    color: var(--color-neutral-900);
  }

  .helps {
    display: flex;
    flex-direction: column;
    gap: var(--space-small-x);

    .helpPrompt {
      padding: var(--space-small-x);
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-regular);

      .content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;

        .text {
          font-weight: var(--font-weight-medium);
          color: var(--color-neutral-900);
        }

        .icon {
          color: var(--color-brand-primary-400);
        }
      }
    }
  }
}
</style>
